import albumsApi from '@pages/albums/albumsApi'
import albumsSlice from '@pages/albums/albumsSlice'
import authSlice from '@pages/login/authSlice'
import cartsApi from '@pages/carts/cartsApi'
import cartSlice from '@components/cart/cartSlice'
import couponsApi from '@pages/coupons/couponsApi'
import paymentsApi from '@pages/costs/paymentsApi'
import usersApi from '@pages/users/usersApi'
import dashboardApi from '@pages/dashboard/dashboardApi'
import filtersSlice from '@components/filters/filtersSlice'
import mainApi from '@src/mainApi'
import mainSlice from '@src/mainSlice'
import ordersApi from '@pages/orders/ordersApi'
import ordersSlice from '@pages/orders/ordersSlice'
import photosApi from '@components/photos/photosApi'
import syncApi from '@pages/sync/syncApi'
import uploadSlice from '@pages/upload/uploadSlice'
import statsApi from '@pages/stats/statsApi'
import storesApi from '@pages/stores/storesApi'
import addOnsApi from '@pages/addons/addOnsApi'
import localsApi from '@pages/locals/localsApi'
import { configureStore } from '@reduxjs/toolkit'

export default configureStore({
  reducer: {
    [albumsApi.reducerPath]: albumsApi.reducer,
    [albumsSlice.name]: albumsSlice.reducer,
    [authSlice.name]: authSlice.reducer,
    [cartsApi.reducerPath]: cartsApi.reducer,
    [cartSlice.name]: cartSlice.reducer,
    [couponsApi.reducerPath]: couponsApi.reducer,
    [paymentsApi.reducerPath]: paymentsApi.reducer,
    [usersApi.reducerPath]: usersApi.reducer,
    [dashboardApi.reducerPath]: dashboardApi.reducer,
    [filtersSlice.name]: filtersSlice.reducer,
    [mainApi.reducerPath]: mainApi.reducer,
    [mainSlice.name]: mainSlice.reducer,
    [ordersApi.reducerPath]: ordersApi.reducer,
    [ordersSlice.name]: ordersSlice.reducer,
    [photosApi.reducerPath]: photosApi.reducer,
    [syncApi.reducerPath]: syncApi.reducer,
    [uploadSlice.name]: uploadSlice.reducer,
    [statsApi.reducerPath]: statsApi.reducer,
    [storesApi.reducerPath]: storesApi.reducer,
    [addOnsApi.reducerPath]: addOnsApi.reducer,
    [localsApi.reducerPath]: localsApi.reducer,
  },
  middleware: (getDefaultMiddleware) => {
    return [
      ...getDefaultMiddleware(),
      albumsApi.middleware,
      cartsApi.middleware,
      couponsApi.middleware,
      paymentsApi.middleware,
      usersApi.middleware,
      dashboardApi.middleware,
      mainApi.middleware,
      ordersApi.middleware,
      photosApi.middleware,
      syncApi.middleware,
      statsApi.middleware,
      storesApi.middleware,
      addOnsApi.middleware,
      localsApi.middleware,
    ]
  },
})
